import { createBrowserHistory } from "history";
import { Sender } from "xstate";
import { FilterQuery } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { categoryFilters } from "../filter/available_filters";
import {
  deserializeFilterFromPath,
  serializeFilterToPath,
} from "../filter/helpers/filter_url_serialization";

const history = createBrowserHistory();

export const serializeCurrentFilter = (appliedFilter: FilterQuery) =>
  serializeFilterToPath(
    history.location.pathname,
    categoryFilters,
    appliedFilter
  );

export const deserializeCurrentUrl = (
  categoryId: number,
  landingPageFilter: object,
  location = history.location
) =>
  deserializeFilterFromPath(
    categoryFilters,
    categoryId,
    landingPageFilter,
    getPath(location.pathname, location.search)
  );

export const getPath = (
  pathname = window.location.pathname,
  search = window.location.search
) => pathname + search;

export const observeUrlChanges = (
  { filter }: { filter: FilterQuery },
  _event: unknown
) => (callback: Sender<any>) => {
  return history.listen(({ location }) => {
    callback({
      type: "ALTER_FILTER",
      newFilter: deserializeCurrentUrl(filter.categoryId, location),
    });
  });
};
